"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFundsOriginCommunityInvestmentTrads = void 0;
exports.EFundsOriginCommunityInvestmentTrads = {
    donation: "Donation",
    goods_before_marriage: "Biens acquis avant le mariage",
    succession: "Succession",
    other: "Autre",
};
